import React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'

const StyledFormField = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  grid-column: ${(props) => (props.$fullWidth ? 'span 2' : 'span 1')};
  
  @media (max-width: 640px) {
    grid-column: span 1;
  }
`

interface FormFieldProps {
  fullWidth?: boolean
  children?: React.ReactNode
  className?: string
}

export const FormField: React.FC<FormFieldProps> = ({ fullWidth, children = null, className = '' }) => {
  return (
    <StyledFormField $fullWidth={fullWidth} className={className}>
      {children}
    </StyledFormField>
  )
}
